export default __webpack_public_path__ + "static/media/sigheMachine.38c898d1.png";